import dayjs from 'dayjs'

const dateToString = (date, format="MM/DD/YYYY") => date ? dayjs(date).format(format).toString() : null
const stringToDate = date => date ? dayjs(date).toDate() : null

export { dateToString, stringToDate}